import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const UserSignup = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phoneNumber, setPhoneNumber] = useState(''); // Add phone number state
    const [showPassword, setShowPassword] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_URL}/api/user/register`, { name, email, password, phoneNumber }); // Send phone number
            navigate("/userlogin");
        } catch (err) {
            console.error(err.response.data.msg);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="main-container">
            {/* Header */}
            <header className="header">
                <div className="container">
                    <div className="header-content">
                        <div className="header-logo">Lememeprix</div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="main-content">
                <div className="signup-container">
                    <div className="signup-background">
                        <img
                            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/7183815703-988d3526216e8a844f30.png"
                            alt="modern french bakery interior"
                        />
                        <div className="signup-overlay"></div>
                    </div>

                    <div className="signup-card">
                        <div className="signup-card-content">
                            <h2 className="signup-title">Créer un compte</h2>

                            <form className="signup-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="fullName">Nom complet</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="text"
                                            id="fullName"
                                            placeholder="Entrez votre nom complet"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                        {name && <i className="fa-solid fa-check check-icon"></i>}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email">Adresse e-mail</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="email"
                                            id="email"
                                            placeholder="Entrez votre adresse e-mail"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                        {email && <i className="fa-solid fa-check check-icon"></i>}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="phoneNumber">Numéro de téléphone</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="tel"
                                            id="phoneNumber"
                                            placeholder="+33 1 23 45 67 89"
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                        />
                                        {phoneNumber && <i className="fa-solid fa-check check-icon"></i>}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="password">Mot de passe</label>
                                    <div className="input-wrapper">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            placeholder="Créer un mot de passe fort"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <i className="fa-solid fa-eye password-toggle" onClick={togglePasswordVisibility}></i>
                                    </div>
                                    {/* Password Strength Meter */}
                                    <div className="password-strength">
                                        <div className="strength-bars">
                                            <div className="strength-bar"></div>
                                            <div className="strength-bar"></div>
                                            <div className="strength-bar"></div>
                                            <div className="strength-bar"></div>
                                        </div>
                                        <p className="strength-text">Force du mot de passe : Faible</p>
                                    </div>
                                </div>

                                <div className="form-group terms">
                                    <input
                                        type="checkbox"
                                        id="terms"
                                        checked={termsAccepted}
                                        onChange={() => setTermsAccepted(!termsAccepted)}
                                    />
                                    <label htmlFor="terms">
                                        J'accepte les <span className="terms-link">Conditions d'utilisation</span> et la <span className="terms-link">Politique de confidentialité</span>
                                    </label>
                                </div>

                                <button type="submit" className="create-account-button">
                                    Créer un compte
                                </button>

                                <p className="already-have-account">
                                    Vous avez déjà un compte ? <span className="sign-in-link">Se connecter</span>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h4 className="footer-title">Liens rapides</h4>
                            <ul className="footer-links">
                                <li><span className="footer-link">À propos de nous</span></li>
                                <li><span className="footer-link">Contact</span></li>
                                <li><span className="footer-link">Politique de confidentialité</span></li>
                            </ul>
                        </div>
                        <div className="footer-section">
                            <h4 className="footer-title">Suivez-nous</h4>
                            <div className="social-icons">
                                <span className="social-icon"><i className="fa-brands fa-facebook"></i></span>
                                <span className="social-icon"><i className="fa-brands fa-instagram"></i></span>
                                <span className="social-icon"><i className="fa-brands fa-twitter"></i></span>
                            </div>
                        </div>
                        <div className="footer-section">
                            <h4 className="footer-title">Assistance</h4>
                            <p>Besoin d'aide ? Contactez-nous :</p>
                            <div className="contact-info">
                                <i className="fa-solid fa-phone"></i>
                                <span>+33 1 23 45 67 89</span>
                            </div>
                            <div className="contact-info">
                                <i className="fa-solid fa-envelope"></i>
                                <span>support@lememeprix.com</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <style jsx>{`
            .main-container {
              min-height: 100vh;
              background-color: #fff;
            }

            /* Header */
            .header {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              background-color: #fff;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              z-index: 50;
            }

            .header .container {
              max-width: 1200px;
              margin: 0 auto;
              padding: 0 1rem;
            }

            .header-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1rem;
            }

            .header-logo {
              font-size: 1.5rem;
              font-weight: bold;
            }

            /* Main Content */
            .main-content {
              padding-top: 5rem;
            }

            .signup-container {
              position: relative;
              min-height: 800px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .signup-background {
              position: absolute;
              inset: 0;
              z-index: 0;
            }

            .signup-background img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .signup-overlay {
              position: absolute;
              inset: 0;
              background-color: rgba(0, 0, 0, 0.6);
            }

            .signup-card {
              position: relative;
              z-index: 10;
              background-color: #fff;
              border-radius: 1.25rem;
              box-shadow: 0 1.25rem 2.5rem -0.625rem rgba(0, 0, 0, 0.25);
              width: 100%;
              max-width: 480px;
              margin: 0 1rem;
            }

            .signup-card-content {
              padding: 2rem;
            }

            .signup-title {
              font-size: 2.25rem;
              font-weight: bold;
              margin-bottom: 1.5rem;
              text-align: center;
            }

            .signup-form {
              display: flex;
              flex-direction: column;
              gap: 1.5rem;
            }

            .form-group {
              display: flex;
              flex-direction: column;
            }

            .form-group label {
              font-size: 0.875rem;
              font-weight: 500;
              margin-bottom: 0.25rem;
            }

            .input-wrapper {
              position: relative;
            }

            .input-wrapper input {
              width: 100%;
              padding: 0.75rem 1rem;
              border: 1px solid #d1d5db;
              border-radius: 0.5rem;
              outline: none;
            }

            .input-wrapper input:focus {
              border-color: #000;
            }

            .check-icon {
              position: absolute;
              right: 0.75rem;
              top: 50%;
              transform: translateY(-50%);
              color: #16a34a;
            }

            .password-toggle {
              position: absolute;
              right: 0.75rem;
              top: 50%;
              transform: translateY(-50%);
              color: #9ca3af;
              cursor: pointer;
            }

            /* Password Strength Meter */
            .password-strength {
              margin-top: 0.5rem;
            }

            .strength-bars {
              display: flex;
              gap: 0.5rem;
            }

            .strength-bar {
              height: 0.25rem;
              flex: 1;
              background-color: #e5e7eb;
              border-radius: 9999px;
            }

            .strength-bar:first-child .strength-bar-inner {
              background-color: #ef4444;
            }

            .strength-text {
              font-size: 0.75rem;
              color: #6b7280;
              margin-top: 0.25rem;
            }

            /* Terms Checkbox */
            .form-group.terms {
              flex-direction: row;
              align-items: center;
            }

            .form-group.terms input {
              width: auto;
              margin-right: 0.5rem;
            }

            /* The label for the terms and conditions */
            .form-group.terms label {
                font-size: 0.875rem;
                font-weight: 500;
                color: #6B7280; /* A slightly darker shade of gray for better readability */
            }

            .terms-link {
              color: #000;
              font-weight: 500;
              cursor: pointer;
              text-decoration: none; /* Removes the underline for a cleaner look */
            }

            .terms-link:hover {
              text-decoration: underline;
            }

            /* Create Account Button */
            .create-account-button {
              padding: 1rem;
              border-radius: 0.5rem;
              background-color: #dc2626;
              color: #fff;
              font-weight: 500;
              cursor: pointer;
              transition: background-color 0.2s ease;
              border: none;
            }

            .create-account-button:hover {
              background-color: #b91c1c;
            }

            .already-have-account {
              text-align: center;
              font-size: 0.875rem;
            }

            .sign-in-link {
              color: #000;
              font-weight: 500;
              cursor: pointer;
              text-decoration: none;
            }

            .sign-in-link:hover {
              text-decoration: underline;
            }

            /* Footer */
            .footer {
              background-color: #f9fafb;
              padding: 3rem 0;
            }

            .footer .container {
              max-width: 1200px;
              margin: 0 auto;
              padding: 0 1rem;
            }

            .footer-content {
              display: grid;
              grid-template-columns: repeat(1, 1fr);
              gap: 2rem;
            }

            @media (min-width: 768px) {
              .footer-content {
                grid-template-columns: repeat(3, 1fr);
              }
            }

            .footer-section {
              display: flex;
              flex-direction: column;
            }

            .footer-title {
              font-size: 1.25rem;
              font-weight: bold;
              margin-bottom: 1rem;
            }

            /* Updated Footer Links styling */
            .footer-links {
                list-style: none;
                padding: 0;
                margin: 0;
            }

            .footer-links li {
                margin-bottom: 0.5rem; /* Adds spacing between link items */
            }

            .footer-link {
              color: #4b5563;
              cursor: pointer;
              transition: color 0.2s ease;
              text-decoration: none;
            }

            .footer-link:hover {
              color: #6b7280;
            }


            .social-icons {
              display: flex;
              gap: 1rem;
            }

            .social-icon {
              font-size: 1.5rem;
              color: #4b5563;
              cursor: pointer;
              transition: color 0.2s ease;
            }

            .social-icon:hover {
              color: #6b7280;
            }

            /* Contact info styling */
            .contact-info {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                margin-bottom: 0.5rem;
                color: #4b5563;
            }
            `}</style>
        </div>
    );
};

export default UserSignup;